import { AsyncThunkOptions, AsyncThunkPayloadCreator, createAsyncThunk, createSelector } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "../../app/store"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const selectorOf = <T>(selectorFn: (state: RootState) => T) => createSelector(selectorFn, (s) => s)

/**
 * Wrapper around createAsyncThunk to add types to dispatch and state
 * @param typePrefix
 * @param payloadCreator
 * @param options
 */
export function asyncThunkOf<Returned, ThunkArg = void, ThunkApiConfig = { dispatch: AppDispatch; state: RootState }>(
    typePrefix: string,
    // @ts-ignore ThunkApiConfig is supposed to extend AsyncThunkApiConfig but the libray does not expose AsyncThunkApiConfig as a type
    payloadCreator: AsyncThunkPayloadCreator<Returned, ThunkArg, ThunkApiConfig>,
    // @ts-ignore ThunkApiConfig is supposed to extend AsyncThunkApiConfig but the libray does not expose AsyncThunkApiConfig as a type
    options?: AsyncThunkOptions<ThunkArg, ThunkApiConfig>
) {
    return createAsyncThunk<Returned, ThunkArg, { dispatch: AppDispatch; state: RootState }>(
        typePrefix,
        // @ts-ignore this library has insane type signatures that try to be too clever
        payloadCreator,
        options
    )
}

/**
 * Just an alias of asyncThunkOf to reduce confusion, since the action doesn't actually need to be async
 */
export const thunkOf = asyncThunkOf
